/* Movatic WMS — Mobile Count | CesarFilho 932048016 */
export default function Count() {
    return (
        <div className="py-3 grid gap-3">
            <div className="card p-3">
                <div className="font-semibold">Contagem</div>
                <div className="text-sm text-neutral-500 mt-1">
                    Contagem cega/dirigida; leia local, produto e quantidades. (fluxo guiado)
                </div>
            </div>
        </div>
    )
}
